import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { TrashIcon } from 'lucide-react'
import { ConfirmationDialog } from '@/components/ui/ConfirmationDialog'

type EstateVisitDeleteButtonProps = {
  onConfirm: () => void
  enabled: boolean
}

export const EstateVisitDeleteButton = ({
  onConfirm,
  enabled,
}: EstateVisitDeleteButtonProps) => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  return (
    <div className="tw-flex tw-justify-between tw-grow tw-content-center">
      <Button
        variant="destructive"
        size="sm"
        onClick={() => setShowConfirmation(true)}
        disabled={!enabled}
      >
        <TrashIcon className="tw-h-4 tw-w-4" />
      </Button>
      <ConfirmationDialog
        open={!!showConfirmation}
        onOpenChange={() => setShowConfirmation(false)}
        onConfirm={() => {
          onConfirm()
          setShowConfirmation(false)
        }}
      />
    </div>
  )
}
